export default function () {
	/**
	 * Sticky header
	 */
	document.addEventListener('DOMContentLoaded', () => {
		const header = document.getElementById('header')
		if (!header) return

		const STICKY_CLASS = 'sticky'
		const stickyOffset = header.offsetTop

		const handleScroll = () => {
			if (window.scrollY > stickyOffset) {
				header.classList.add(STICKY_CLASS)
			} else {
				header.classList.remove(STICKY_CLASS)
			}
		}

		window.addEventListener('scroll', handleScroll, { passive: true })
		handleScroll()
	})

	document.addEventListener('DOMContentLoaded', () => {
		const toggleBtn = document.querySelector('[data-mobile-menu-toggle]')
		const drawer = document.querySelector('[data-mobile-menu-drawer]')
		const overlay = document.querySelector('[data-mobile-menu-overlay]')
		const container = document.querySelector('[data-mobile-menu-container]')
		const closeBtn = document.querySelector('[data-mobile-menu-close]')

		const openMenu = () => {
			if (!toggleBtn || !drawer || !overlay || !container) return

			drawer.classList.add('is-active')
			overlay.classList.add('is-active')
			container.classList.add('is-active')
		}

		const closeMenu = () => {
			if (!toggleBtn || !drawer || !overlay || !container) return

			drawer.classList.remove('is-active')
			overlay.classList.remove('is-active')
			container.classList.remove('is-active')
		}

		if (!toggleBtn || !drawer || !overlay) return

		toggleBtn.addEventListener('click', (e) => {
			e.preventDefault()
			if (drawer.classList.contains('is-active')) {
				closeMenu()
			} else {
				openMenu()
			}
		})

		closeBtn?.addEventListener('click', (e) => {
			e.preventDefault()
			closeMenu()
		})

		container?.addEventListener('click', (e) => {
			if (e.target && e.target.href && e.target.href.includes('#')) {
				closeMenu()
			}
		})

		overlay.addEventListener('click', closeMenu)

		window.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				closeMenu()
			}
		})
	})
}
